module.exports = __webpack_public_path__ + "img/details3.b472750b.png";